<template>
  <div>
    <section class="py-9">
      <div class="container" v-if="produtDetail">
        <div class="row g-4">

          <!-- Product Images -->
          <div class="col-lg-6">
            <div class="border rounded p-3">
              <img :src="activeImage" class="img-fluid rounded w-100 mb-3" alt="Product" />
              <div class="d-flex gap-2 flex-wrap">
                <img
                  v-for="(img, index) in produtDetail.images"
                  :key="index"
                  :src="img"
                  class="img-thumbnail"
                  style="width: 80px; cursor: pointer;"
                  @click="activeImage = img"
                />
              </div>
            </div>
          </div>

          <!-- Product Info -->
          <div class="col-lg-6 text-start">
            <h2 class="mb-3">{{ produtDetail.name }}</h2>

            <div class="mb-2">
              <span v-if="produtDetail.offerPrice" class="h4 me-2">
                ₹{{ produtDetail.offerPrice }}
              </span>
              <span :class="{
                'h4': !produtDetail.offerPrice,
                'text-muted text-decoration-line-through': produtDetail.offerPrice
              }">
                ₹{{ produtDetail.price }}
              </span>
            </div>

            <p class="text-muted">{{ produtDetail.shortDescription }}</p>

            <!-- Quantity -->
            <div class="d-flex align-items-center mb-4">
              <label class="me-3 fw-bold">Quantity:</label>
              <div class="input-group" style="width:120px;">
                <button class="btn btn-outline-secondary" type="button" @click="decreaseQty">-</button>
                <input type="text" class="form-control text-center" v-model="qty" readonly>
                <button class="btn btn-outline-secondary" type="button" @click="increaseQty">+</button>
              </div>
            </div>

            <p><strong>Category:</strong> Keychains</p>
            <p><strong>Tags:</strong> Handmade, Gift, Accessories</p>

            <!-- ✅ Desktop buttons: below tags, order: WhatsApp → Cart → Buy Now -->
            <!-- ✅ Desktop buttons -->
            <div class="d-none d-md-flex gap-3 mt-4 flex-wrap">
              <button class="btn btn-whatsapp" @click="orderOnWhatsapp(produtDetail)">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:-2px; margin-right:5px;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.117.549 4.107 1.51 5.833L.057 23.535a.75.75 0 0 0 .916.927l5.834-1.53A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.708 9.708 0 0 1-4.95-1.355l-.355-.211-3.666.962.978-3.58-.231-.368A9.715 9.715 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/></svg>
                Order on WhatsApp
              </button>
              <button class="btn btn-cart" @click="addProductToCart(produtDetail, false)">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px; margin-right:1px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                Add to Cart
              </button>
              <button class="btn btn-buy" @click="addProductToCart(produtDetail, true)">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px; margin-right:5px;"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>
                Buy Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- ✅ Mobile sticky bar: WhatsApp → Cart → Buy Now, safe-area aware -->
    <div class="mobile-action-bar d-flex d-md-none" v-if="produtDetail">
      <button class="btn btn-whatsapp flex-fill" @click="orderOnWhatsapp(produtDetail)">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:-2px; margin-right:4px;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.117.549 4.107 1.51 5.833L.057 23.535a.75.75 0 0 0 .916.927l5.834-1.53A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.708 9.708 0 0 1-4.95-1.355l-.355-.211-3.666.962.978-3.58-.231-.368A9.715 9.715 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/></svg>
        WhatsApp
      </button>
      <button class="btn btn-cart flex-fill" @click="addProductToCart(produtDetail, false)">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        Cart
      </button>
      <button class="btn btn-buy flex-fill" @click="addProductToCart(produtDetail, true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px; margin-right:4px;"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>
        Buy Now
      </button>
    </div>

  </div>
</template>

<script>
import { useToast } from 'vue-toast-notification';
const $toast = useToast();
import ProductService from "../services/ProductService";
import { EventBus } from '@/eventBus';

const WHATSAPP_NUMBER = "919512981118"; // 🔁 Replace: country code + number, no + or spaces

export default {
  name: 'ProductDetail',
  data() {
    return {
      slug: this.$route.params.slug,
      produtDetail: null,
      activeImage: "",
      qty: 1,
    };
  },
  methods: {
    increaseQty() { this.qty++; },
    decreaseQty() { if (this.qty > 1) this.qty--; },

    orderOnWhatsapp(product) {
      const price = product.offerPrice || product.price;
      const message =
        `Hi! I'd like to place an order\n\n` +
        `*Product:* ${product.name}\n` +
        `*Price:* Rs.${price}\n` +
        `*Qty:* ${this.qty}\n` +
        `*Total:* Rs.${price * this.qty}\n\n` +
        `Please confirm availability and share payment details. Thank you!`;
      window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, "_blank");
    },

    getProductDetail() {
      ProductService.getProductDetail({ slug: this.slug })
        .then((response) => {
          this.produtDetail = response.data.data;
          if (this.produtDetail.images?.length > 0) {
            this.activeImage = this.produtDetail.images[0];
          }
        })
        .catch((e) => { $toast.error(e.response.data.respones_msg); });
    },

    async addProductToCart(product, redirectToCartPage = false) {
      await ProductService.addProductToCart({
        productId: product._id,
        productDetail: product,
        qty: this.qty,
      })
        .then((response) => {
          EventBus.emit('cart-updated');
          $toast.success(response.data.respones_msg);
          if (redirectToCartPage) this.$router.push({ path: '/cart' });
        })
        .catch((e) => { $toast.error(e.response.data.respones_msg); });
    },
  },
  mounted() { this.getProductDetail(); }
};
</script>
<style scoped>
.py-9 {
  padding-top: 9rem !important;
  padding-bottom: 3rem !important;
}

@media (max-width: 767px) {
  .py-9 {
    padding-bottom: calc(88px + env(safe-area-inset-bottom)) !important;
  }
}

/* ✅ Shared base style for ALL three buttons — same size, radius, font */
.btn-whatsapp,
.btn-cart,
.btn-buy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 20px;
  border-radius: 8px;        /* consistent radius across all three */
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
}

.btn-whatsapp:hover,
.btn-cart:hover,
.btn-buy:hover {
  opacity: 0.88;
}

/* Individual colours */
.btn-whatsapp {
  background-color: #25D366;
  color: #ffffff;
}

.btn-cart {
  background-color: #6c9e9e;   /* match your existing teal shade */
  color: #ffffff;
}

.btn-buy {
  background-color: #111111;
  color: #ffffff;
}

/* ✅ Sticky bar */
.mobile-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border-top: 1px solid #dee2e6;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  gap: 8px;
}

/* Slightly smaller text in the narrow mobile bar */
.mobile-action-bar .btn-whatsapp,
.mobile-action-bar .btn-cart,
.mobile-action-bar .btn-buy {
  font-size: 13px;
  padding: 0 10px;
}
</style>